export default __webpack_public_path__ + "static/media/doc.bd7dbeef.svg";